import { DateTime } from 'luxon';
import { User as KaizenIdUser } from '@kaizenplatform/kaizen-offer-entity';

class User extends KaizenIdUser {
  constructor({
    id,
    name,
    profileImageUrl,
    description,
    createdAt,
    assignments,
    candidates,
    email,
  }: Pick<
    KaizenIdUser,
    'id' | 'name' | 'profileImageUrl' | 'description' | 'createdAt' | 'assignments' | 'candidates' | 'email'
  >) {
    super({ id, name, profileImageUrl, description, createdAt, assignments, candidates, email });
  }

  public static fromJSON = (value: any) => {
    const {
      id,
      name,
      profileImageUrl,
      description,
      createdAt: _createdAt,
      assignments,
      candidates,
      email,
    } = Object.assign({}, value);

    const createdAt = DateTime.fromISO(_createdAt);

    if (typeof id !== 'string') throw new TypeError('.id must be a string');
    if (typeof name !== 'string') throw new TypeError('.name must be a string');
    if (profileImageUrl && typeof profileImageUrl !== 'string')
      throw new TypeError('.profileImageUrl must be a string');
    if (description && typeof description !== 'string') {
      throw new TypeError('.description must be a string');
    }
    if (email && typeof email !== 'string') {
      throw new TypeError('.email must be a string');
    }

    return new User({
      id,
      name,
      profileImageUrl,
      description,
      createdAt,
      assignments,
      candidates,
      email,
    });
  };
}

export default User;
